import { useRentalUnitField } from '../../../../../../../../queries/useRentalUnitField';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../../../../../components/ApplicationQuestionReviewItem';
import { ShowIf } from '../../../../../../../components/ShowIf';

interface OccupiedProps {
    unitGuid: string;
    required?: boolean;
    isReview?: boolean;
    showLabel?: boolean;
    width?: string;
}

export const Occupied: React.FC<OccupiedProps> = ({
    unitGuid,
    required = false,
    isReview = false,
    showLabel = false,
    width = '100%',
}) => {
    const label = 'Occupied';
    const [occupied, set_occupied] = useRentalUnitField(
        unitGuid,
        (u) => u.occupied,
        (u, v) => ({ ...u, occupied: v })
    );

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_occupied(true);
                return;
            case 'no':
                set_occupied(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <>
                    <ShowIf showIf={showLabel}>
                        <ApplicationQuestionReviewItem
                            label={label}
                            value={occupied ? 'Yes' : 'No'}
                            showLabel={showLabel}
                        />
                    </ShowIf>
                    <ShowIf showIf={!showLabel}>{occupied ? 'Yes' : 'No'}</ShowIf>
                </>
            ) : (
                <YesNoToggleButton
                    id={`occupied_${unitGuid}`}
                    value={occupied}
                    onItemClick={toggleButtonYesNoClick}
                    width={width}
                    required={required}
                    label={showLabel && label}
                    labelSize={ToggleButtonLabelSize.Small}
                />
            )}
        </>
    );
};
